import { expVal } from '@atlassian/jira-feature-experiments';

const JiraTimelineGroupByRelayprovider = {
	get(): boolean {
		return expVal('jira_timeline_group_by', 'isEnabled', false);
	},
};

export default JiraTimelineGroupByRelayprovider;
